import { useEffect, useState } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { useFormattedDate } from './useFormattedDate';
import { messages } from '../../i18n/messages';
export const useAvailableFromDate = (timestamp, availableFromCode, availableFrom) => {
    const labelLater = useI18n(messages.availableLaterLabel);
    const descriptionLater = useFormattedDate(timestamp);
    const labelNow = useI18n(messages.availableNowLabel);
    const descriptionNow = useI18n(messages.availableNowDescription);
    const labelSoon = useI18n({
        id: 'nemo.ui.sc.tiles.expected.availability',
        defaultMessage: 'Availability',
    });
    const descriptionSoon = availableFrom || '';
    const [label, setLabel] = useState('');
    const [description, setDescription] = useState('');
    useEffect(() => {
        if (availableFromCode === 'date') {
            setLabel(labelLater);
            setDescription(descriptionLater);
        }
        else if (availableFromCode === 'now') {
            setLabel(labelNow);
            setDescription(descriptionNow);
        }
        else if (availableFromCode === 'soon') {
            setLabel(labelSoon);
            setDescription(descriptionSoon);
        }
    }, [descriptionLater, descriptionNow, labelLater, labelNow, timestamp]);
    return [label, description];
};
